const dataProtectionLinkGenerate = (companyName: string, id: string) => {
  const link = `https://dataprivacy.wisestep.com/data-protection/email/${companyName}/${id}`;
  return link;
};
export default dataProtectionLinkGenerate;
